module.exports = __webpack_public_path__ + "static/media/IMG_039.05f94b6c.JPG";